export const subjectConcerns = [
    {
        value: '0',
        subject: 'Bitte wählen ...',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
        ],
    },
    {
        value: '1',
        subject: 'Bestellung',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich kann nicht bestellen.',
            },
            {
                value: '2',
                concern: 'Ich möchte eine Bestellung ändern/stornieren.',
                additionalFields: [
                    {type: 'text', label: 'Auftragsnummer', name: 'orderNumber'},
                ],
            },
            {
                value: '3',
                concern: 'Wo ist meine Bestellung?',
            },
            {
                value: '4',
                concern: 'Bestellkarte',
            },
        ],
    },
    {
        value: '2',
        subject: 'Rechnungen/Zahlung',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich benötige eine Rechnung.',
            },
            {
                value: '2',
                concern: 'Ich vermisse meine Zahlung (Überweisung).',
                additionalFields: [
                    {type: 'text', label: 'Kontoinhaber', name: 'accountHolder'},
                    {type: 'text', label: 'IBAN', name: 'iban'},
                    {type: 'text', label: 'Betrag', name: 'amount'},
                    {type: 'text', label: 'Zahlungsdatum', name: 'paymentDate'},
                    {type: 'text', label: 'Verwendungszweck', name: 'purpose'},
                ],
            },
            {
                value: '3',
                concern: 'Ich vermisse meine Zahlung (Paypal).',
                additionalFields: [
                    {type: 'text', label: 'Name des Einzahlers', name: 'paypalName'},
                    {type: 'text', label: 'Paypal E-Mail-Adresse', name: 'paypalEmail'},
                    {type: 'text', label: 'Betrag', name: 'paypalAmount'},
                    {type: 'text', label: 'Zahlungsdatum', name: 'paypalPaymentDate'},
                    {type: 'text', label: 'Transaktionscode', name: 'paypalTransactionCode'},
                ],
            },
            {
                value: '4',
                concern: 'Ich vermisse meine Zahlung (Lastschrift & Vorauskasse).',
                additionalFields: [
                    {type: 'text', label: 'Kontoinhaber', name: 'accountHolder'},
                    {type: 'text', label: 'IBAN', name: 'iban'},
                    {type: 'text', label: 'Betrag', name: 'amount'},
                    {type: 'text', label: 'Zahlungsdatum', name: 'paymentDate'},
                    {type: 'text', label: 'Verwendungszweck', name: 'purpose'},
                ],
            },
            {
                value: '5',
                concern: 'Ich vermisse meine Zahlung (Kreditkarte).',
            },
            {
                value: '7',
                concern: 'Ich verstehe meinen Kontostand nicht.',
            },
            {
                value: '8',
                concern: 'Ich habe eine Frage zu meiner Rechnung.',
            },
            {
                value: '9',
                concern: 'Ich möchte mein Guthaben auszahlen lassen.',
                additionalFields: [
                    {type: 'text', label: 'Kontoinhaber', name: 'accountHolder'},
                    {type: 'text', label: 'IBAN', name: 'iban'},
                ],
            },
        ],
    },
    {
        value: '3',
        subject: 'Rücksendung/Reklamation',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich möchte etwas zurückschicken.',
                additionalFields: [
                    {type: 'text', label: 'Rechnungsnummer', name: 'invoiceNumber'},
                    {type: 'text', label: 'Rechnungsdatum', name: 'paymentDate'},
                ],
            },
            {
                value: '2',
                concern: 'Eine Retourengutschrift fehlt.',
                additionalFields: [
                    {type: 'text', label: 'Rechnungsnummer', name: 'invoiceNumber'},
                    {type: 'text', label: 'Artikelnummer', name: 'articleNumber'},
                    {type: 'text', label: 'Größe', name: 'articleSize'},
                    {type: 'text', label:'Rücksendedatum', name: 'returnDate'},
                    {type: 'text', label: 'Quittungsnummer', name: 'receiptNumber'},
                ],
            },
            {
                value: '3',
                concern: 'Versandkostenerstattung fehlt',
            },
            {
                value: '4',
                concern: 'Artikel ist fehlerhaft.',
                additionalFields: [
                    {type:'text', label: 'Rechnungsnummer', name: 'invoiceNumber'},
                    {type: 'text', label: 'Artikelnummer', name: 'articleNumber'},
                    {type: 'text', label: 'Größe', name: 'articleSize'},
                ]
            },
            {
                value: '5',
                concern: 'Ich habe unvollständige oder falsche Ware erhalten.',
                additionalFields: [
                    {type: 'text', label: 'Auftragsnummer', name: 'orderNumber'},
                    {type: 'text', label: 'Artikelnummer', name: 'articleNumber'},
                    {type: 'text', label: 'Größe', name: 'articleSize'},
                    {type: 'text', label: 'Rechnungsnummer', name: 'invoiceNumber'},
                ]
            },
        ],
    },
    {
        value: '4',
        subject: 'Meine Daten/Benutzerkonto',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich kann mich nicht in Mein Konto anmelden.',
                additionalFields: [
                    {type: 'text', label: 'Straße und Hausnummer', name: 'street'},
                    {type: 'text', label: 'PLZ und Ort', name: 'zipAndCity'},
                ]
            },
            {
                value: '2',
                concern: 'Ich möchte meine persönlichen Daten ändern.',
            },
            {
                value: '3',
                concern: 'Ich möchte mein Benutzerkonto löschen.',
            },
        ],
    },
    {
        value: '5',
        subject: 'Artikel',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich wünsche mehr Artikel Informationen.',
                additionalFields: [
                    {
                        type: 'groupOfMultipleEntries',
                        addButtonLabel: 'weitere Artikel',
                        fields: [
                            {type: 'text', label: 'Artikelnummer', name: 'articleNumbers'},
                            {type: 'text', label: 'Größe', name: 'articleSizes'},
                        ],
                    },
                ],
            },
            {
                value: '2',
                concern: 'Ich möchte ein Ersatzteil für Möbel.',
                additionalFields: [
                    {type: 'text', label: 'Artikelnummer', name: 'articleNumber'},
                    {type: 'text', label: 'Ersatzteilbezeichnung', name: 'partName'},
                ],
            },
            {
                value: '3',
                concern: 'Meldung von potenziellen Verletzungen',
                additionalFields: [
                    {type: 'text', label: 'Artikelnummer', name: 'articleNumber'},
                    {type: 'text', label: 'Größe', name: 'articleSize'},
                ],
            },
        ],
    },
    {
        value: '6',
        subject: 'Newsletter/Katalog',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich möchte euren Newsletter.',
            },
            {
                value: '2',
                concern: 'Ich möchte mich vom Newsletter abmelden',
            },
            {
                value: '3',
                concern: 'Ich möchte euren Katalog bestellen.',
            },
            {
                value: '4',
                concern: 'Ich möchte euren Katalog abbestellen.',
            },
        ],
    },
    {
        value: '7',
        subject: 'Gutschein',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich kann meinen Gutschein nicht einlösen',
                additionalFields: [
                    {type: 'text', label: 'Gutscheincode oder Newsletter-Betreff', name: 'voucherCode'},
                    {type: 'text', label: 'Höhe des Rabatts', name: 'discountAmount' },
                ]
            },
            {
                value: '2',
                concern: 'Wie lauten die Einlösebedingungen?',
            },
        ],
    },
    {
        value: '8',
        subject: 'Sonstige Fragen',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Sonstige Fragen',
            },
        ],
    },
];
